import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Clock, ShieldCheck, CreditCard, Sparkles, Droplets } from 'lucide-react';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="oferta-final" className="py-24 bg-gradient-to-b from-brand-pink/20 via-brand-pink/10 to-brand-dark px-4 relative" data-id="element-87">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-88">
        {/* Surprise bonus */}
        <div className="relative bg-white text-brand-dark border-4 border-brand-pink rounded-2xl p-5 md:p-6 mb-10 shadow-[0_0_40px_rgba(255,0,128,0.4)] animate-pulse-slow" data-id="element-89">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-pink text-white px-4 py-1 rounded-full text-xs font-black uppercase tracking-wider flex items-center gap-1.5" data-id="element-90">
            <Sparkles className="w-3.5 h-3.5" data-id="element-91" />
            Bono Sorpresa
          </div>
          <div className="flex items-center justify-center gap-3 mt-2" data-id="element-92">
            <Droplets className="w-8 h-8 md:w-10 md:h-10 text-brand-pink shrink-0" data-id="element-93" />
            <p className="text-base md:text-xl font-black uppercase leading-tight" data-id="element-94">
              Calculadora de Proteínas e Hidratación{' '}
              <span className="text-brand-pink" data-id="element-95">GRATIS por HOY</span>
            </p>
          </div>
        </div>

        <div className="bg-brand-pink/10 border border-brand-pink/30 rounded-2xl p-4 md:p-6 mb-10 inline-flex flex-col items-center" data-id="element-96">
          <div className="flex items-center gap-2 text-brand-pink font-bold mb-2 uppercase tracking-wider" data-id="element-97">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-98" />
            La oferta expira en:
          </div>
          <div className="flex gap-4 text-3xl md:text-5xl font-black text-white" data-id="element-99">
            <div className="flex flex-col items-center" data-id="element-100">
              <span className="bg-zinc-900 px-4 py-2 rounded-lg border border-zinc-800 shadow-inner" data-id="element-101">
                {String(timeLeft.hours).padStart(2, '0')}
              </span>
              <span className="text-xs text-zinc-500 mt-1 uppercase" data-id="element-102">
                Horas
              </span>
            </div>
            <span className="text-brand-pink py-2" data-id="element-103">:</span>
            <div className="flex flex-col items-center" data-id="element-104">
              <span className="bg-zinc-900 px-4 py-2 rounded-lg border border-zinc-800 shadow-inner" data-id="element-105">
                {String(timeLeft.minutes).padStart(2, '0')}
              </span>
              <span className="text-xs text-zinc-500 mt-1 uppercase" data-id="element-106">Min</span>
            </div>
            <span className="text-brand-pink py-2" data-id="element-107">:</span>
            <div className="flex flex-col items-center" data-id="element-108">
              <span className="bg-zinc-900 px-4 py-2 rounded-lg border border-zinc-800 shadow-inner" data-id="element-109">
                {String(timeLeft.seconds).padStart(2, '0')}
              </span>
              <span className="text-xs text-zinc-500 mt-1 uppercase" data-id="element-110">Seg</span>
            </div>
          </div>
        </div>

        <div className="bg-white text-brand-dark border-4 border-brand-pink rounded-3xl p-8 md:p-12 shadow-[0_0_80px_rgba(255,0,128,0.35)]" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-2" data-id="element-112">
            Acceso Completo + 6 Bonos
          </h2>
          <p className="text-zinc-600 mb-8 font-medium" data-id="element-113">
            Pago único, acceso de por vida.
          </p>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-114">
            <span className="text-xl md:text-2xl text-zinc-400 line-through font-bold mb-2" data-id="element-115">
              Precio normal: $52.690
            </span>
            <div className="flex items-start justify-center gap-1" data-id="element-116">
              <span className="text-4xl font-bold text-brand-pink mt-2" data-id="element-117">$</span>
              <span className="text-7xl md:text-8xl font-black text-brand-dark leading-none tracking-tighter" data-id="element-118">
                19.899
              </span>
            </div>
            <span className="text-emerald-700 font-bold mt-4 bg-emerald-100 px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-119">
              Ahorrás $32.791 hoy
            </span>
          </div>

          <Button className="w-full text-lg md:text-2xl py-6 mb-6 shadow-[0_10px_40px_rgba(255,0,128,0.4)]" data-id="element-120">
            DOMINÁ TUS PARTIDOS
          </Button>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-zinc-600 font-medium" data-id="element-121">
            <div className="flex items-center gap-2" data-id="element-122">
              <ShieldCheck className="w-5 h-5 text-emerald-500" data-id="element-123" />
              Compra 100% Segura
            </div>
            <div className="flex items-center gap-2" data-id="element-124">
              <CreditCard className="w-5 h-5 text-brand-pink" data-id="element-125" />
              Todos los medios de pago
            </div>
          </div>
        </div>
      </div>
    </section>;
}